<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <div class="report" v-if="Object.keys(reportDetails).length !== 0" @click.stop="">

    <!-- Basic info -->
    <span class="span-header mb-3">
      {{ reportDetails.type === INS_USER ? $t('ins_report_details.user_title') : $t('ins_report_details.title') }}
      <span v-if="getInspectionTarget(reportDetails)">
          - {{ getInspectionTarget(reportDetails) }}
      </span>
    </span>
        <table class="table table-sm table-fixed">
            <tbody>
            <tr>
                <td class="item-detail-title">
                    {{ reportDetails.type === INS_USER ? $t('ins_report_details.user_date') : $t('ins_report_details.date') }}
                </td>
                <td class="item-detail-text">
                    {{ toLocalTime(reportDetails.created) }}
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('ins_report.list_label.report_type') }}
                </td>
                <td class="item-detail-text">
                    {{ getInspectionTypeName(reportDetails.type) }}
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('ins_report.list_label.name') }}
                </td>
                <td class="item-detail-text">
                    {{ reportDetails.name }}
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('inspection_editor.inspection_frequency') }}
                </td>
                <td class="item-detail-text">
                    {{ getInspectionFrequency(reportDetails.frequency) }}
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ reportDetails.type === INS_USER ? $t('ins_report_details.user_inspector') : $t('ins_report_details.inspector') }}
                </td>
                <td class="item-detail-text">
                    {{ getInspector(reportDetails.reporter) }}
                </td>
            </tr>
            <tr v-if="reportDetails.areas">
                <td class="item-detail-title">
                    {{ $t('menu.areas') }}
                </td>
                <td class="item-detail-text">
                    {{ reportDetails.areas.map(item => item.name).join(', ') }}
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('ins_report.info') }}
                </td>
                <td class="item-detail-text">
                    {{ reportDetails.info }}
                </td>
            </tr>
            <tr>
                <td class="item-detail-title">
                    {{ $t('weather_station.location') }}
                </td>
                <td class="item-detail-text link" @click.stop="$emit('locationClick', reportDetails.location.y, reportDetails.location.x)">
                    {{ reportDetails.location === undefined ? $t('inspection.unknown_location') : reportDetails.location.x.toFixed(6) + " " + reportDetails.location.y.toFixed(6) }}
                    <font-awesome-icon v-if="reportDetails.location" icon="map" class="mx-2"></font-awesome-icon>
                </td>
            </tr>
            </tbody>
        </table>

        <!-- Inspector qualifications/ certificates -->
        <div  v-if="reportDetails !== undefined && reportDetails.inspected_company || reportDetails !== undefined && reportDetails.reporter.certificates" class="col-12 nopads">
            <span class="span-header">
              {{ reportDetails.type === INS_USER ? $t('ins_report_details.user_reporter_certificates') : $t('ins_report_details.reporter_certificates') }}
            </span>
            <inspector-certificates v-if="reportDetails.reporter.certificates.length > 0"
                                    :certificates="reportDetails.reporter.certificates"/>
            <span v-else>-</span>
        </div>

        <!-- Target information -->
        <span class="span-header">
      {{ reportDetails.type === INS_USER ? $t('ins_report_details.user_target') : $t('ins_report_details.target') }}
    </span>
        <target-info-vehicles v-if="reportDetails.vehicle" :vehicle="reportDetails.vehicle"/>
        <target-info-bridge v-if="reportDetails.bridge_id" :bridge-id="reportDetails.bridge_id"/>
        <target-info-culvert v-if="reportDetails.culvert_id" :culvert-id="reportDetails.culvert_id"/>
        <target-info-contract v-if="reportDetails.contract" :contract="reportDetails.contract"/>
        <target-info-order v-if="reportDetails.order" :order="reportDetails.order"/>
        <target-info-company v-if="reportDetails.inspected_company" :company="reportDetails.inspected_company"/>

        <!--Inspection results-->
     <span class="span-header">
      {{ reportDetails.type === INS_USER ? $t('ins_report_details.user_ins_results') : $t('ins_report_details.ins_results') }}
    </span>
        <div
            v-if="reportDetails.results && reportDetails.results.length"
            class="col-sm-12 panel-group data-container"
        >
            <vue3-datatable
                ref="resultTable"
                :rows="results"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                height="100%"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
            >
                <template #result="row">
                    <span v-if="row.value.result.none"
                          class="ms-1"
                          :class="{resultOk: 'text-success', resultDefect: 'text-warning', resultBan: 'text-danger'}[row.value.result.none]"
                    >
                        {{ getInspectionResultName(row.value.result.none) }}
                    </span>
                    <span v-if="row.value.result.number">
                        <div class="inline nopads">
                            {{ row.value.result.number }}
                        </div>
                    </span>
                    <span v-if="row.value.result.text">
                        <div class="inline nopads">
                            {{ row.value.result.text }}
                        </div>
                    </span>
                    <span v-if="row.value.result.select_single">
                        <div class="inline nopads">
                            {{ row.value.result.select_single.name }}
                        </div>
                    </span>
                    <span v-if="row.value.result.select_multi && row.value.result.select_multi.length > 0">
                        <div v-for="selection in row.value.result.select_multi" :key="selection.id" class="inline nopads me-1 ">
                            {{ selection.name }}
                        </div>
                    </span>
                    <span v-if="row.value.result.boolean !== undefined">
                        <div class="inline nopads">
                            {{ $t(row.value.result.boolean ? 'common.yes' : 'common.no') }}
                        </div>
                    </span>
                </template>
                <template #photos="row">
                    <div v-if="row.value.photos && row.value.photos.length > 0" class="text-right" style="height: 15em">
                        <ImageView
                            v-for="photo in row.value.photos" :key="photo.id"
                            ref="image"
                            :contain="true"
                            class="flicking-panel"
                            :url="getReportPhotoUrl(row.value.id, photo)"
                            :cache-photo="true"
                            :cacheable-photo-id="photo.id"
                            @click="openImage(row.value.id, photo)"
                            :controlSize="'sm'"
                        />
                    </div>
                </template>
            </vue3-datatable>
        </div>
        <Transition name="fade" >
            <fullscreen-image
                v-if="showPhoto"
                :url="getReportPhotoUrl(this.itemId, this.photo)"
                @close="closePhoto"/>
        </Transition>
        <comment-container
            class="pt-2"
            :topic="commentTopics.TOPIC_INSPECTION_REPORTS"
            :id="reportDetails.id"
            :user="user"
            :type="reportDetails.type"/>
    </div>
</template>

<script>
import {vehicleHelper} from '../mixins/VehicleMixin'
import {inspectionHelper} from '../mixins/InspectionMixin'
import TargetInfoVehicles from "./TargetInfoVehicles";
import TargetInfoContract from "./TargetInfoContract";
import TargetInfoOrder from "./TargetInfoOrder";
import {timeUtils} from "../mixins/TimeUtils";
import {commentTopics} from "@/components/mixins/CommentMixin";
import InspectorCertificates from "./InspectorCertificates";
import TargetInfoCompany from "./TargetInfoCompany";
import {restApi} from '../mixins/RestApiMixin'
import FullscreenImage from "../view/FullscreenImage";
import TargetInfoBridge from "@/components/inspections/TargetInfoBridge";
import TargetInfoCulvert from "@/components/inspections/TargetInfoCulvert";
import ImageView from "@/components/view/ImageView.vue";
import CommentContainer from "@/components/comments/CommentContainer";
import Vue3Datatable from '@bhplugin/vue3-datatable'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";


export default {
    name: 'InspectionReportDetails',
    components: {
        FontAwesomeIcon,
        Vue3Datatable,
        CommentContainer,
        ImageView,
        TargetInfoCulvert,
        TargetInfoBridge,
        FullscreenImage,
        TargetInfoCompany,
        InspectorCertificates,
        TargetInfoOrder,
        TargetInfoContract,
        TargetInfoVehicles
    },
    mixins: [vehicleHelper, inspectionHelper, timeUtils, restApi],
    props: {
        user: {
            type: Object,
            default: null
        },
        reportDetails: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            itemId: null,
            photo: null,
            showPhoto: false,
            fields: [
                {field: 'inspectable', title: this.$t('ins_report_details.inspectable'), sort: true, headerClass: 'routa-table-header' },
                {field: 'result', title: this.$t('ins_report_details.result'), sort: true, headerClass: 'routa-table-header' },
                {field: 'info', title: this.$t('ins_report_details.info'), sort: false, headerClass: 'routa-table-header' },
                {field: 'photos', title: this.$t('ins_report_details.photos'), cellClass: 'photo-col', sort: false, headerClass: 'routa-table-header' }
            ]
        }
    },

    computed: {
        commentTopics() {
            return commentTopics
        },
        results() {
            if(this.reportDetails !== undefined) {
                return this.reportDetails.results.map(({id, inspectable, info, photos, number, text, select_single, select_multi, boolean, result: res}) => {
                    let result;
                    if (number != null) {
                        result = { number };
                    }
                    else if (text != null) {
                        result = { text };
                    }
                    else if (select_single != null) {
                        result = { select_single };
                    }
                    else if (select_multi != null) {
                        result = { select_multi };
                    }
                    else if (boolean != null) {
                        result = { boolean };
                    }
                    else {
                        result = { none: res };
                    }
                    return { id, inspectable, result, info, photos }
                });
            }
            else {
                return {}
            }

        }
    },

    methods: {
        openImage: function (resultId, photo) {
            this.itemId = resultId
            this.photo = photo
            this.showPhoto = true
        },
        closePhoto() {
            this.showPhoto = false
        },
        getReportPhotoUrl: function (resultId, photo) {
            if (photo && photo.id) {
                return this.inspectionResult + resultId + '/photo/' + photo.id + '?inspection_type=' + this.reportDetails.type
            }
            return null
        }
    }
}
</script>
<style>
.photo-col {
    width: 300px;
    text-align: center;
}
</style>
